module.exports = __webpack_public_path__ + "media/images/pic/courses/ryotaro-sakamoto-c6899ddf1992266fa022d8cf34a2b535.png";